import React from "react";
import PropTypes from "prop-types";

import Checkbox from "components/checkbox";
import styles from "./checkBoxGroup.scss";

function CheckBoxGroup({
	options,
	value = [],
	getKey = (option) => option.id,
	getName = (option) => option.displayName,
	onChange,
	onBlur,
}) {
	const isOptionSelected = (option) => {
		return value.some((selectedOption) => getKey(selectedOption) === getKey(option));
	};

	const handleClickOnOption = (option) => {
		let newValue;
		if (isOptionSelected(option)) {
			newValue = value.filter((selectedOption) => getKey(selectedOption) !== getKey(option));
		} else {
			newValue = [...value, option];
		}
		onChange(newValue);
	};

	const renderOption = (option) => (
		<Checkbox
			key={getKey(option)}
			checked={isOptionSelected(option)}
			onChange={() => handleClickOnOption(option)}
			onBlur={onBlur}
		>
			{getName(option)}
		</Checkbox>
	);

	return options && options.length > 0 ? <div className={styles.check_box_group}>{options.map(renderOption)}</div> : null;
}

CheckBoxGroup.propTypes = {
	options: PropTypes.array,
	value: PropTypes.array,
	getKey: PropTypes.func,
	getName: PropTypes.func,
	onChange: PropTypes.func,
	onBlur: PropTypes.func,
};

export default CheckBoxGroup;
